import { useCallback } from 'react'
import GenericTabsSmall from '../../genericTabs/GenericTabsSmall'
import { Paper } from '@mui/material'
import { useStyles } from './styles'
import { useDispatch, useSelector } from 'react-redux'
import { selectAlertsTab } from '../../../selectors/alerts'
import { AlertsTabType, setAlertsTab } from '../../../reducer/alerts.reducer'

//ensure these enum strings match with AlertsTabType
export enum AlertTab {
    ALERTS = 'alerts',
    LOG = 'log'
}

const navItems = [
    {
        key: AlertTab.ALERTS,
        label: 'Alerts'
    },
    {
        key: AlertTab.LOG,
        label: 'Log'
    }
]

const AlertsHeader = () => {
    const { classes } = useStyles()
    const dispatch = useDispatch()
    const selectedAlertsTab = useSelector(selectAlertsTab)

    const handleAlertTypeChange = useCallback(
        (value: AlertTab) => {
            if ([AlertTab.LOG, AlertTab.ALERTS].includes(value)) {
                dispatch(setAlertsTab(value.toString() as AlertsTabType))
            }
        },
        [dispatch]
    )

    return (
        <Paper className={classes.container}>
            <GenericTabsSmall<AlertTab>
                items={navItems}
                onChange={handleAlertTypeChange.bind(this)}
                value={selectedAlertsTab as AlertTab}
                tabProps={{
                    sx: {
                        display: 'flex',
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                        textAlign: 'center',
                        // backgroundColor: (theme) => theme.palette.background.default,
                        // '&.Mui-selected': {
                        //     backgroundColor: (theme) => theme.palette.background.paper,
                        //     backgroundImage: (theme) => (theme.palette.mode === 'dark' ? 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)) !important' : ''),
                        //     ':hover': {
                        //         backgroundColor: (theme) => theme.palette.background.paper,
                        //         backgroundImage: (theme) => (theme.palette.mode === 'dark' ? 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)) !important' : '')
                        //     }
                        // }
                    }
                }}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    backgroundColor: (theme) => theme.palette.background.default
                }}
            />
        </Paper>
    )
}

export default AlertsHeader
